/* unplugin-vue-components disabled */import script from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=5d96d14a&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\www.changshun.com\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d96d14a"]])

export default __exports__